<template>
  <div class="header">
      <img src = "public/ui/ur-logo.svg" alt="University of Rochester Logo" class="header__logo"/>
  </div>
</template>

<script>
export default {
  name: 'MapHeader',
  publicPath: process.env.BASE_URL
}
</script>

<style scoped lang="scss">
@import '../scss/colors.scss';

.header {
  padding: 17px 0 17px 20px;
  border-bottom: 1px solid $gray;
  overflow: auto;
}
.header__logo {
  width: 239px;
  // display: inline-block;
  float:left;
}
</style>